// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overflow{
    overflow: hidden;
}

.folder-title{
    padding-left: 0 !important;
    font-weight: 600 !important;
    color: #48465b !important;
    font-size: 1.1rem !important;
    margin:  6px 0 !important;
}

.kt-todo .kt-portlet__head{
    min-height: 55px !important;
}

.dropzone-container {
  height: 100px;
  border: 2px dashed #b3deee;
}
.m-h-30{
    min-height: 30px;
}

img.picture{
    width: 100%;
    height: 150px;
    object-fit: cover;
}

/* .header-titles{

} */
`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/list/list.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;;GAEG","sourcesContent":[".overflow{\r\n    overflow: hidden;\r\n}\r\n\r\n.folder-title{\r\n    padding-left: 0 !important;\r\n    font-weight: 600 !important;\r\n    color: #48465b !important;\r\n    font-size: 1.1rem !important;\r\n    margin:  6px 0 !important;\r\n}\r\n\r\n.kt-todo .kt-portlet__head{\r\n    min-height: 55px !important;\r\n}\r\n\r\n.dropzone-container {\r\n  height: 100px;\r\n  border: 2px dashed #b3deee;\r\n}\r\n.m-h-30{\r\n    min-height: 30px;\r\n}\r\n\r\nimg.picture{\r\n    width: 100%;\r\n    height: 150px;\r\n    object-fit: cover;\r\n}\r\n\r\n/* .header-titles{\r\n\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
